// extracted by css-extract-rspack-plugin
export default {"input":"input__spL7L","icon":"icon__fSrPX"};